<script>

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Stoch',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Stochastic',
                preset: {
                    name: 'Stoch $param_k $param_d $smooth',
                    side: 'offchart',
                    settings: {
                        lineWidth: 0.75,
                        kColor: '#3782f2',
                        dColor: '#f48709',
                        bandColor: '#ddd',
                        backColor: '#381e9c16'
                    }
                }
            }
        },
        draw(ctx) {

            const layout = this.$props.layout

            drawIndicatorPlot(ctx, this.$props.data, layout, this.sett, 0, {color:this.k_color,width:this.line_width})
            drawIndicatorPlot(ctx, this.$props.data, layout, this.sett, 1, {color:this.d_color,width:this.line_width})


        },
        use_for() { return ['Stoch'] },
        data_colors() { return [this.k_color, this.d_color] },
        y_range(hi, lo) {
            return [
                Math.max(hi, this.sett.upper ?? 80),
                Math.min(lo, this.sett.lower ?? 20)
            ]
        },
        calc() {
            return {
                props: {
                    param_k: { def: 14, text: 'K' },
                    param_d: { def: 3, text: 'D' },
                    smooth: { def: 3, text: 'Smooth' },
                },
                update: `
                    let k = sma(stoch(close, high, low, param_k), smooth)
                    let d = sma(k, param_d)
                    return [k[0], d[0]]
                `
            }
        }
    },
    computed: {
        sett() {
            return this.$props.settings
        },
        line_width() {
            return this.sett.lineWidth || 0.75
        },
        k_color() {
            return this.sett.kColor || '#3782f2'
        },
        d_color() {
            return this.sett.dColor || '#f48709'
        },
        band_color() {
            return this.sett.bandColor || '#ddd'
        },
        back_color() {
            return this.sett.backColor || '#381e9c16'
        }
    }

}
</script>
